<div class="header">
    <nav class="header_top">
      <div class="header_menu">
        <div class="header_menu_icon" routerLink="/">
          <mat-icon>menu</mat-icon>
  
        </div>
        <img routerLink="/" src="http://pngimg.com/uploads/amazon/amazon_PNG11.png" class="header_menu_logo" alt="">
     <div class="header_menu_searchbar">
       <input type="text" class="header_menu_input">
       <div class="header_menu_searchbar_icon">
         <mat-icon>search</mat-icon>
  
       </div>
     </div>
     <div routerLink="/login" class="header_menu_signin">
       <span class="header_menu_top_item">Hello, Sign in</span>
       <span class="header_menu_bottom_item">Accounts & Lists</span>
  
     </div>
     <div routerLink="/login" class="header_menu_signin">
      <span class="header_menu_top_item">Returns</span>
      <span class="header_menu_bottom_item">& Orders</span>
  
    </div>
    <div  routerLink="/checkout" class="header_menu_cart">
      <mat-icon>shopping_cart</mat-icon>
      <p class="header_cart_number">{{shoppingCart.getCartLength()}}</p>
    </div>
      </div>
  
    </nav>
    <nav class="header_bottom">
      <div class="header_bottom_location_text">
        <span class="header_left_line_one">Delivery to</span>
        <span  class="header_left_line_two"> <Strong>India</Strong></span>
    </div>
    </nav>
  </div>